import { Injectable } from '@angular/core';

@Injectable()
export class AppSettingsService {
    public readonly LoginPath: string = '/login';
    public readonly UsersPath: string = '/users';
    public readonly AdminDashboardPath: string = '/dashboard-admin';
    public readonly UnauthorizedPath: string = '/unauthorized';
    public readonly Content: string = '/content';
    public readonly Campaigns: string = '/campaigns';
    public readonly CampaignDetails: string = '/campaign-details';
    public readonly BrandLogos: string = '/brand-logos';
    public readonly BrandPreId: string = '/brand-preid';
    public readonly BrandStatistics: string = '/brand-statistics';
    public readonly Mediation: string = '/mediation';
    public readonly Payment: string = '/payment';
    public readonly AutoLogin: string = '/auto-login';
    public readonly ForgotPassword: string = 'reset-password';
    public readonly DemandSources: string = '/demand-sources';
    public readonly Providers: string = '/providers';
    public readonly Settings: string = '/settings';
    public readonly Publishers: string = '/publishers';
    public readonly PublisherDashboardPath: string = '/dashboard';
    public readonly ReportsPath: string = '/reports';
    public readonly Creative: string ="/creatives";
    public readonly Asset: string ="/assets";
}


// WEBPACK FOOTER //
// ./src/app/core/services/app-settings.service.ts